export default __webpack_public_path__ + "static/media/styles.7c65f1a0.svg";